/* eslint-disable max-len */
import { Heading, Text } from 'evergreen-ui';
import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';

function Terms() {
  useEffect(() => {
    document.title = 'Terms and Conditions · WappGrow';
  }, []);

  function heading(text, fontSize = 20) {
    return (<Heading fontSize={fontSize}>{text}</Heading>);
  }
  function link(text) {
    return (<a style={{ color: '#027eb5' }} href="http://orkaapps.com/">{text}</a>);
  }
  function content(text) {
    return (<Text fontSize={18} lineHeight={1.5}>{text}</Text>);
  }
  return (
    <div
      style={{
        width: '70%', padding: '50px 0px', margin: 'auto', rowGap: 22, display: 'flex', flexDirection: 'column',
      }}
    >
      {heading(
        <>
          Terms and Conditions for
          {' '}
          {link('orkaapps.com')}
        </>,
        25,
      )}
      {heading('Last Updated: November 1, 2023')}
      {content(
        <>
          Welcome to
          {' '}
          {link('orkaapps.com')}
          , a leading online marketplace. Please read these Terms and Conditions carefully before using our website. By accessing or using our services, you agree to be bound by these Terms and Conditions. If you do not agree to all of the terms and conditions, please do not use our services.
        </>,
      )}
      {heading('1. Acceptance of Terms')}
      {content('By accessing this website, you are agreeing to be bound by these website Terms and Conditions, all applicable laws, and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site.')}
      {heading('2. Use License')}
      {content(
        <>
          a. Permission is granted to temporarily download one copy of the materials (information or software) on
          {' '}
          {link('orkaapps.com')}
          's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license, you may not:
        </>,
      )}
      {content(
        <>
          <p style={{ margin: 0 }}>i. modify or copy the materials;</p>
          <p style={{ margin: 0 }}>ii. use the materials for any commercial purpose or for any public display (commercial or non-commercial);</p>
          <p style={{ margin: 0 }}>
            iii. attempt to decompile or reverse engineer any software contained on
            {' '}
            {link('orkaapps.com')}
            's website;
          </p>
          <p style={{ margin: 0 }}>iv. remove any copyright or other proprietary notations from the materials; or</p>
          <p style={{ margin: 0 }}>v. transfer the materials to another person or "mirror" the materials on any other server.</p>
        </>,
      )}
      {content(
        <>
          b. This license shall automatically terminate if you violate any of these restrictions and may be terminated by
          {' '}
          {link('orkaapps.com')}
          {' '}
          at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession, whether in electronic or printed format.
        </>,
      )}
      {heading('3. Disclaimer')}
      {content(
        <>
          The materials on
          {' '}
          {link('orkaapps.com')}
          's website are provided on an 'as is' basis.
          {' '}
          {link('orkaapps.com')}
          {' '}
          makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
        </>,
      )}
      {heading('4. Limitations')}
      {content(
        <>
          In no event shall
          {' '}
          {link('orkaapps.com')}
          {' '}
          or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on
          {' '}
          {link('orkaapps.com')}
          's website, even if
          {' '}
          {link('orkaapps.com')}
          {' '}
          or a
          {' '}
          {link('orkaapps.com')}
          {' '}
          authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.
        </>,
      )}
      {heading('5. Revisions and Extra')}
      {content(
        <>
          The materials appearing on
          {' '}
          {link('orkaapps.com')}
          's website could include technical, typographical, or photographic errors.
          {' '}
          {link('orkaapps.com')}
          {' '}
          does not warrant that any of the materials on its website are accurate, complete, or current.
          {' '}
          {link('orkaapps.com')}
          {' '}
          may make changes to the materials contained on its website at any time without notice.
        </>,
      )}
      {heading('6. Links')}
      {content(
        <>
          {link('orkaapps.com')}
          {' '}
          has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by
          {' '}
          {link('orkaapps.com')}
          {' '}
          of the site. Use of any such linked website is at the user's own risk.
        </>,
      )}
      {heading('7. Site Terms of Use Modifications')}
      {content(
        <>
          {link('orkaapps.com')}
          {' '}
          may revise these terms of use for its website at any time without notice. By using this website you are agreeing to be bound by the then-current version of these Terms and Conditions.
        </>,
      )}
      {heading('8. Governing Law')}
      {content(
        <>
          Any claim relating to
          {' '}
          {link('orkaapps.com')}
          's website shall be governed by the laws of the jurisdiction of India without regard to its conflict of law provisions
        </>,
      )}
      {content(
        <>
          By accessing this website, you agree to these terms and conditions. If you do not agree, please do not use our website.
        </>,
      )}
      {content(
        <>
          If you have any questions or concerns about these Terms and Conditions, please contact us at [
          {link('contact@orkaapps.in')}
          ].
        </>,
      )}
    </div>
  );
}

export { Terms };
